import {
  BusinessModelComponent,
  Comment,
  Competitor,
  Epic,
  Feature,
  Goal,
  Idea,
  IdeaTheme,
  Initiative,
  KeyResult,
  Page,
  Persona,
  Project,
  ProjectStrategyComponent,
  Release,
  ReleasePhase,
  Requirement,
  Task,
} from 'components/framework/models';
import { type RecordId } from 'javascripts/shared-types';

// The list of defined searchable document types
export const SearchableModels = {
  BusinessModelComponent,
  Comment,
  Competitor,
  Epic,
  Feature,
  Goal,
  Idea,
  IdeaTheme,
  Initiative,
  KeyResult,
  Page,
  Persona,
  Project,
  ProjectStrategyComponent,
  Release,
  ReleasePhase,
  Requirement,
  Task,
} as const;

export type SearchableModelType = keyof typeof SearchableModels;
export type SearchableRecordType =
  (typeof SearchableModels)[SearchableModelType];
export type SearchableRecord = InstanceType<SearchableRecordType>;

export type SearchableRecordIdentifier = `${SearchableModelType}-${RecordId}`;

export const SearchableModelTypes = Object.keys(
  SearchableModels
) as SearchableModelType[];

export const isSearchableType = (
  searchableType: string
): searchableType is SearchableModelType =>
  SearchableModelTypes.includes(searchableType);
